const TransmittalRoutes = {

    path: '/app',
    component: () => import('@/layouts/blank/BlankTransmittal.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        // {
        //     name: 'Transmittal to College',
        //     path: '/applications/transmittal-college/ocs/:college',
        //     component: () => import('@/views/applications/TransmittalOcs.vue')
        // },
       {
        name: 'transmittal-download',
        path: '/applications/transmittal/:batch',
        component: () => import('@/views/applications/TransmittalToProgram.vue')
       }
    ],
   

};

export default TransmittalRoutes;